<div id="filter-search" class="filter search inactive" [style.width]="width | px2rem">
    <div class="search-icon"><mat-icon class="icon">search</mat-icon></div>
    <div class="input"><input type="text" [(ngModel)]="keyword" (keyup)="searchUser()" [placeholder]="placeholderStr"></div>
</div>